
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/works-on-paper",
      function () {
        return require("private-next-pages/works/works-on-paper.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works/works-on-paper"])
      });
    }
  